import React, {Component} from 'react';
import {connect} from 'react-redux';
import Action from './actions';

class PlayerTeamStacking extends Component {
    onCheck(isChecked) {
        const {playerId} = this.props;
        this.props.dispatch(Action.set('UsageOfPlayersOnlyInTeamStacking', {playerIds: [playerId], isChecked}));
    }

    render() {
        const {players, playerId} = this.props;
        let {className = ''} = this.props;

        const isChecked = players.isOnlyInTeamStackingUsed(playerId);
        if (isChecked) {
            className += ' active';
        }

        return (
            <button
                type="button"
                className={className}
                onClick={() => ::this.onCheck(!isChecked)}
                title={isChecked ? 'Chain to Stacking enabled' : 'Chain to Stacking disabled'}
            >
                {isChecked ? 'Chain to Stacking enabled' : 'Chain to Stacking disabled'}
            </button>
        );
    }
}

function mapStatesToProps(state) {
    const {nonControlledHitterStacking} = state;

    return {
        players: nonControlledHitterStacking.players,
    };
}

export default connect(mapStatesToProps)(PlayerTeamStacking);
